





































































































import {cloneDeep} from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import Table from '@c/tables/Table.vue';
import IconButton from '@c/controls/IconButton.vue';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import Loading from '@c/controls/Loading.vue';
import DeleteDialog from '@c/DeleteDialog.vue';
import {Can} from '@casl/vue';
import {OilNodeData, OilNodeTableHeader} from './interfaces';
import oilModule from '@/store/modules/entities/oilModule';
import oilReportModule from '@/store/modules/entities/oilReportModule';
import nodeModule from '@/store/modules/entities/nodeModule';
import {NodeData} from '@/system/nodes/interfaces';
import {httpClient} from '@/api/baseApi';
import router from '@/router';

@Component({
  components: {
    Breadcrumbs,
    IconButton,
    Table,
    Loading,
    DeleteDialog,
    Can,
  },
})
export default class OilAdminView extends Vue {
  loadingTree = true;
  errorTree = false;

  get apiStore() {
    oilReportModule.setOid(+this.$router.currentRoute.params.id);
    return oilReportModule;
  }

  sortDMYdate(a: string, b: string) {
    const dmy1 = a.split('.');
    const dmy2 = b.split('.');
    return (
      new Date(+dmy1[2], +dmy1[1] - 1, +dmy1[0]).getTime() -
      new Date(+dmy2[2], +dmy2[1] - 1, +dmy2[0]).getTime()
    );
  }

  headers: OilNodeTableHeader[] = [
    {
      value: 'samplingDate',
      text: 'Дата отбора',
      sortable: true,
      sort: (a, b) => this.sortDMYdate(a, b),
    },
    {value: 'sample_id', text: 'Идентификатор образца', sortable: true},
    {value: 'oil_type', text: 'Тип масла', sortable: true},
    {value: 'reportType', text: 'Тип отчета', sortable: true},
    {
      value: 'receptionDate',
      text: 'Дата получения',
      sortable: true,
      sort: (a, b) => this.sortDMYdate(a, b),
    },
    {
      value: 'reportDate',
      text: 'Дата заключения',
      sortable: true,
      sort: (a, b) => this.sortDMYdate(a, b),
    },
    {value: 'machine_hour', text: 'Моточасы, ч', sortable: true},
    {value: 'oil_hour', text: 'Срок службы масла, ч', sortable: true},
    {value: 'append_oil', text: 'Долив масла, л', sortable: true},
  ];

  oilNode: OilNodeData = {nodeId: 0, measurements: []};
  nodesPath: NodeData[] = [];
  nodeItems: NodeData[] = [];

  getPathByNodeId(id: number): NodeData[] {
    const stack = [...this.nodeItems];
    const prev: Record<string, NodeData> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: NodeData[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id ? node.id : 0]) {
          node = prev[node.id ? node.id : 0];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          if (c.id) {
            prev[c.id] = x;
            stack.push(c);
          }
        });
    }
    return [];
  }

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren(item: NodeData) {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  }

  oId!: number;

  async updateReportsTable() {
    const ORM = this.apiStore;
    await ORM.fetchAll();
  }

  async created() {
    this.oId = +this.$router.currentRoute.params.id;
    await oilModule.fetchAll();
    await nodeModule.fetchAll();
    try {
      const temp = cloneDeep(nodeModule.all);
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.nodeItems = temp;
    } catch {
      this.errorTree = true;
    }
    if (this.oId) {
      const {data} = await oilModule.edit(this.oId);
      this.oilNode = data;
      this.nodesPath = this.getPathByNodeId(+this.oilNode?.nodeId);

      await this.updateReportsTable();
    } else {
      this.errorTree = true;
    }
    this.loadingTree = false;
  }

  addReport() {
    router.push(`/oil/report/${this.oId}/new`);
  }

  importReport() {
    (this.$refs.fileInput as HTMLElement).click();
  }

  async onFileChanged(e: any) {
    if (!e.target.files[0]) return;

    const apiStore = this.apiStore;
    const file = e.target.files[0];
    const reader = new FileReader();
    try {
      this.loadingTree = true;
      reader.onload = async () => {
        const formData = new FormData();
        if (reader.result) {
          const blob = new Blob([reader.result], {type: file.type});
          formData.append('file', blob);
          await apiStore.import(formData);
          await this.updateReportsTable();
        }
      };
      reader.readAsArrayBuffer(file);
    } catch (err) {
      this.errorTree = true;
      console.error('Ошибка при загрузке PDF:', err);
    }
    this.loadingTree = false;
  }

  onChangeNode(item: NodeData) {
    router.push(`/nodes/${item.id}`);
  }

  openAnalysis() {
    router.push(`/oil/report/${this.oId}`);
  }

  editOilNode() {
    router.push(`/oil/${this.oId}`);
  }

  deleteOilNode() {
    this.deleteDialog.open(
      {itemName: `узел анализов масла «${this.oilNode.name}»`, id: this.oilNode.id},
      {
        deleteCallback: async (item: any) => {
          try {
            await oilModule.delete(item.id);
            this.deleteDialog.close();
            router.push('/oil');
          } catch (e) {
            this.deleteDialog.error('Произошла ошибка');
          }
        },
      },
    );
  }

  async viewPDF(item: any) {
    try {
      const {data} = await httpClient.get(`/oil-nodes/${this.oId}/reports/${item.id}/download`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(data);
      window.open(url, '_blank');
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    } catch (error) {
      console.error('Ошибка при загрузке PDF:', error);
      this.$emit('error', 'Не удалось загрузить PDF документ');
    }
  }

  editItem(item: any) {
    router.push(`/oil/report/${this.oId}/${item.id}`);
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  async deleteItem(item: any) {
    this.deleteDialog.open(
      {itemName: `отбор ${item.sample_id}`, id: item.id},
      {
        deleteCallback: async (item: any) => {
          try {
            await this.apiStore.delete(item.id);
            this.deleteDialog.close();
            await this.updateReportsTable();
          } catch (e) {
            this.deleteDialog.error('Произошла ошибка');
          }
        },
      },
    );
  }

  back() {
    router.push('/oil');
  }
}
